<template>
    <page class="invoice-pdf-page">
        <div class="invoice-pdf-preview" v-if="data != null">
            <div class="print-controls">
                <el-button type="info" @click="handleBackBtnClick">返回</el-button>
                <el-button type="primary" @click="handlePrintBtnClick">列印</el-button>
            </div>
            <div class="branding">
                <img class="logo" :src="$store.getters['menu/companyInfo'].logo" alt="" />
            </div>
            <div class="no-break" style="display: flex; justify-content: space-between; font-size: 10pt; font-weight: bold; line-height: 14pt;">
                <h1 style="margin-bottom: 40px;">Invoice {{ data.status }}</h1>
                <div class="no-break">
                    <table style="border: 0">
                        <tr v-if="data.foo && data.foo.trim() !== ''">
                            <td>Invoice No: </td><td>{{ data.foo }}</td>
                        </tr>
                        <tr>
                            <td style="padding-right: 10px;">Invoice Date: </td>
                            <td>{{ date | dateFormater("YYYY-MM-dd") }}</td>
                        </tr>
                    </table>
                    <!-- <div>ID: {{ data.foo }}</div> -->
                </div>
            </div>
            <div class="section no-break">
                <h2>SHIPPER</h2>
                <table class="spec-table">
                    <tr>
                        <th>Company Name:</th>
                        <td>{{ data.eN_CMP }}</td>
                    </tr>
                    <tr>
                        <th>Company Address:</th>
                        <td>{{ data.eN_ADR }}</td>
                    </tr>
                    <tr>
                        <th>Tel:</th>
                        <td>{{ data.tel }}</td>
                    </tr>
                    <tr>
                        <th>E-mail:</th>
                        <td>{{ data.email }}</td>
                    </tr>
                </table>
            </div>
            <div class="section no-break">
                <h2>RECIEVER</h2>
                <table class="spec-table">
                    <tr>
                        <th>Company Name:</th>
                        <td>{{ data.vendorFNAM }}</td>
                    </tr>
                    <tr>
                        <th>Company Address:</th>
                        <td>{{ data.vendorADR }}</td>
                    </tr>
                </table>
            </div>
            <div class="section payouts">
                <table cellpadding="0" cellspacing="0">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th class="right-align">Price</th>
                            <th class="right-align">Unit</th>
                            <th class="right-align">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in data.subItem" :key="item.sno">
                            <td>{{ item.iteM_NAM }}</td>
                            <td class="right-align">
                                <Money :v="item.pri" />
                            </td>
                            <td class="right-align">{{ item.qty }}</td>
                            <td class="right-align">
                                <Money :v="item.amt" />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="total">
                    <span class="currency">{{ data.cny }}</span>
                    <span class="total"> <Money :v="total"/></span>
                </div>
            </div>
            <div class="section no-break">
                <h2>PAYMENT INFO</h2>
                <table class="spec-table">
                    <tr>
                        <th>Bank Account Holder:</th>
                        <td>{{ data.eN_CMP }}</td>
                    </tr>
                    <tr>
                        <th>Bank Name:</th>
                        <td>{{ bankName }}</td>
                    </tr>
                    <!-- <tr>
                        <th>Account Name:</th>
                        <td>{{ accountName }}</td>
                    </tr> -->
                    <tr>
                        <th>Account Number:</th>
                        <td>{{ accountNumber }}</td>
                    </tr>
                    <tr>
                        <th>SWIFT Code:</th>
                        <td>{{ swiftCode }}</td>
                    </tr>
                    <tr v-if="data.serialNumber != null">
                        <th>Serial Number:</th>
                        <td>{{ data.serialNumber }}</td>
                    </tr>
                </table>
            </div>
            <div class="section no-break" v-if="data.comment && data.comment.trim() !== ''">
                <h2>REMARKS</h2>
                <div class="remarks-content">{{ data.comment }}</div>
            </div>
        </div>
    </page>
</template>
<script>
import Page from '@/components/ui/Page.vue';

export default {
    name: 'InvoicePdfPage',
    components: { Page },
    data() {
        return {
            data: null,
        };
    },
    mounted() {
        this.$api({
            url: `/InvoiceManagemnetPage/GetInvocePdfInfo?Sno=${this.$route.params.sno}`,
            method: 'GET',
        }).then((resp) => {
            console.log('Invoice PDF: ', resp);
            this.data = resp.data.item;
        });
    },
    computed: {
        total() {
            let sum = 0;
            for (let i = 0; i < this.data.subItem.length; i += 1) {
                sum += this.data.subItem[i].amt;
            }
            return sum;
        },
        date() {
            return this.data.foO_DAT > 0 ? this.data.foO_DAT : this.data.foO_PDAT;
        },
        swiftCode() {
            return this.$store.getters['menu/companyInfo'].swifT_CODE;
        },
        bankName() {
            return `${this.$store.getters['menu/companyInfo'].eN_BNK} - ${this.$store.getters['menu/companyInfo'].eN_Branch}`;
        },
        accountNumber() {
            return this.$store.getters['menu/companyInfo'].bnK_ACC;
        },
        accountName() {
            return this.$store.getters['menu/companyInfo'].eN_BNK_NAM;
        },
    },
    methods: {
        handlePrintBtnClick() {
            window.print();
        },
        handleBackBtnClick() {
            this.$router.push({ name: 'invoice-detail', params: { sno: this.$route.params.sno } });
        },
    },
};
</script>
<style lang="scss">
@page {
    size: Auto;
    orphans: 4;
    margin-top: 0.5cm;
    widows: 2;
}

.invoice-pdf-preview {
    .page-title {
        @media print {
            display: none;
        }
    }
    aspect-ratio: 3/4;
    max-width: 850px;
    position: relative;
    line-height: 100%;
    background-color: #fff;
    font-size: 9pt;
    margin: 30px auto;
    padding: 75px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    border: 1px solid #eee;

    .branding {
        .logo {
            position: relative;
            width: 2.1cm;
        }
    }

    @media print {
        background-color: #fff;
        margin: 0;
        padding: 0cm 1.5cm 0.5cm 1.5cm;
        border: 0;
        border-radius: 0;
        box-shadow: none;
        aspect-ratio: unset;
    }

    h1 {
        padding: 0.5cm 0 0 0;
        font-size: 35pt;
    }

    .print-controls {
        text-align: right;

        @media print {
            display: none;
        }
    }

    .no-break {
        page-break-inside: avoid;
    }

    .section {
        margin: 1cm 0 1cm 0;

        h2 {
            text-transform: uppercase;
            border-bottom: 1px solid #000;
            font-size: 13pt;
            padding: 0 0 0.2cm 0;
            margin: 0 0 0.2cm 0;
        }

        &.payouts {
            margin: 1cm 0 2.5cm 0;

            table {
                width: 100%;

                .right-align {
                    text-align: right;
                }

                thead {
                    tr {
                        th {
                            text-align: left;
                            padding: 0.1cm 0;
                            border-bottom: 3px solid #000;
                        }
                    }
                }

                tbody {
                    tr {
                        td {
                            padding: 0.1cm 0;
                            border-bottom: 1px solid #000;
                        }
                    }
                }
            }

            .total {
                margin-top: 1cm;
                text-align: right;
                font-size: 15pt;
                font-weight: bold;

                .currency {
                    margin-right: 0.5cm;
                }
            }
        }
    }

    .spec-table {
        th {
            text-align: left;
            width: 4cm;
            font-weight: normal;
            vertical-align: top;
        }
    }

    .remarks-content {
        white-space: pre-line;
    }
}
</style>
